import { render, staticRenderFns } from "./MenuHeader.vue?vue&type=template&id=03d1c472"
import script from "./MenuHeader.vue?vue&type=script&lang=js"
export * from "./MenuHeader.vue?vue&type=script&lang=js"
import style0 from "./MenuHeader.vue?vue&type=style&index=0&id=03d1c472&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports